import React from 'react';
import { FaUsers, FaBriefcase, FaTrophy, FaGraduationCap } from 'react-icons/fa';

const Statistics = () => {
  const stats = [
    {
      icon: <FaUsers className="text-4xl" />,
      number: '10,000',
      label: 'Target Resource Pool',
      description: 'In Next 5 Years',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: <FaBriefcase className="text-4xl" />,
      number: '500+',
      label: 'Students Placed',
      description: 'Top Companies',
      color: 'from-orange-500 to-orange-600'
    },
    {
      icon: <FaTrophy className="text-4xl" />,
      number: '95%',
      label: 'Success Rate',
      description: 'Training Completion',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: <FaGraduationCap className="text-4xl" />,
      number: '20+',
      label: 'Partner Organizations',
      description: 'Colleges & Corporates',
      color: 'from-green-500 to-green-600'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-blue-50" data-testid="statistics-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300"
              data-testid={`stat-card-${index}`}
            >
              <div className={`inline-flex p-4 rounded-lg bg-gradient-to-br ${stat.color} text-white mb-4`}>
                {stat.icon}
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2" data-testid={`stat-number-${index}`}>
                {stat.number}
              </div>
              <div className="text-lg font-semibold text-gray-700 mb-1">
                {stat.label}
              </div>
              <div className="text-sm text-gray-500">
                {stat.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Statistics;